export interface InvestmentDetailData {
    assetInfo: {
        name: string;
        trend: string;
        isPositive: boolean;
        openingBalance: number;
        currentBalance: number;
        change: string;
        currency: string;
    };
    trends: {
        daily: {
            labels: string[];
            values: number[][]; // [low, high, open, close] or similar for candlestick-like look
            displayLabels: string[];
        };
        weekly: {
            labels: string[];
            values: number[][];
            displayLabels: string[];
        };
        monthly: {
            labels: string[];
            values: number[][];
            displayLabels: string[];
        };
        annually: {
            labels: string[];
            values: number[][];
            displayLabels: string[];
        };
    };
}

export const MOCK_INVESTMENT_DETAIL_DATA: InvestmentDetailData = {
    assetInfo: {
        name: 'Apple',
        trend: '+1%',
        isPositive: true,
        openingBalance: 58200,
        currentBalance: 5505000.35,
        change: '+1% 5,505,000.35',
        currency: 'INR'
    },
    trends: {
        daily: {
            labels: Array.from({ length: 4 }, (_, i) => `Point ${i}`),
            values: [
                [20, 50, 30, 40], // Up (Green)
                [30, 70, 60, 40], // Down (Red)
                [45, 85, 75, 55], // Down (Red)
                [25, 65, 35, 55]  // Up (Green)
            ],
            displayLabels: ['5 Jun', '15 Jun', '25 Jun', '5 Jul']
        },
        weekly: {
            labels: ['Week 1', 'Week 2', 'Week 3', 'Week 4'],
            values: [
                [30, 60, 40, 50], // Up (Green)
                [40, 80, 70, 50], // Down (Red)
                [50, 90, 80, 60], // Down (Red)
                [35, 75, 45, 65]  // Up (Green)
            ],
            displayLabels: ['Week 1', 'Week 2', 'Week 3', 'Week 4']
        },
        monthly: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
            values: [
                [20, 50, 30, 40], // Up
                [30, 70, 40, 60], // Up
                [45, 85, 75, 55], // Down
                [25, 95, 85, 35], // Down
                [40, 80, 50, 70], // Up
                [50, 90, 80, 60]  // Down
            ],
            displayLabels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']
        },
        annually: {
            labels: ['2020', '2021', '2022', '2023', '2024'],
            values: [
                [20, 50, 30, 40], // Up
                [30, 70, 60, 40], // Down
                [45, 85, 55, 75], // Up
                [25, 65, 55, 35], // Down
                [40, 80, 50, 70]  // Up
            ],
            displayLabels: ['2020', '2021', '2022', '2023', '2024']
        }
    }
};
